import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { formatDateTime } from "@/common/utils/formatters";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingEstablishmentChoiceEntryProposalData } from "@/features/maintenance/features/workflows/types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse from "./AwaitingEstablishmentReponse";
import EstablishmentChoiceEntryProposalDiagnostic from "./Diagnostic";

interface EstablishmentChoiceEntryProposalProps {
  proposal: MaintenanceForwardingEstablishmentChoiceEntryProposalData;
  showProposalDiagnostic?: boolean;
}

const EstablishmentChoiceEntryProposal = ({ proposal, showProposalDiagnostic }: EstablishmentChoiceEntryProposalProps) => {
  const { forwarding, directiveEntryKlass } = useForwardingTabContext();

  return (
    <>
      {(proposal?.status === 'awaiting_establishment_response') && (
        <EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse />
      )}

      {(proposal?.status !== 'awaiting_establishment_response' || showProposalDiagnostic) && (
        <Box className="p-4 flex flex-col gap-8">
          {(proposal?.status !== 'awaiting_establishment_response') && (
            <div className="flex flex-col gap-3">
              <div>
                <p className="font-semibold">
                  {proposal?.id.split('-')[0]?.toUpperCase()}
                </p>
              </div>

              <div className="flex gap-3">
                {forwarding?.establishment_choice_entry?.process_started_at && (
                  <ResumeItem
                    label="Data de envio"
                    value={formatDateTime(new Date(forwarding?.establishment_choice_entry?.process_started_at))}
                    className="text-xs"
                    valueClassName="font-bold text-sm"
                  />
                )}
              </div>

              {(proposal?.proposal_content?.start_at || proposal?.proposal_content?.deadline_to_complete_in_days != null) && (
                <div className="flex gap-3">
                  {proposal?.proposal_content?.start_at && (
                    <ResumeItem
                      label="Data e hora sugerida"
                      value={formatDateTime(new Date(proposal?.proposal_content?.start_at))}
                      className="text-xs"
                      valueClassName="font-bold text-sm"
                    />
                  )}

                  {proposal?.proposal_content?.deadline_to_complete_in_days != null && (
                    <ResumeItem
                      label={
                        ({
                          [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: 'Prazo para envio do diagnostico e orçamento pós-check-in',
                          [MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]: 'Prazo para execução pós-check-in',
                        } as Partial<Record<MaintenanceForwardingsDirectiveEntryKlass, string>>)[directiveEntryKlass]
                        || 'Prazo para envio pós-check-in'
                      }
                      value={`${proposal?.proposal_content?.deadline_to_complete_in_days} Dias`}
                      className="text-xs"
                      valueClassName="font-bold text-sm"
                    />
                  )}
                </div>
              )}
            </div>
          )}

          {showProposalDiagnostic && (
            <div className="-mx-4 -my-4">
              <EstablishmentChoiceEntryProposalDiagnostic />
            </div>
          )}
        </Box>
      )}
    </>
  );
}

export default EstablishmentChoiceEntryProposal;
